import { render, staticRenderFns } from "./PICK_Benefit.vue?vue&type=template&id=f8b0d5ca&"
import script from "./PICK_Benefit.vue?vue&type=script&lang=js&"
export * from "./PICK_Benefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports